/****************************************************
 * Module Name:  openProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class OpenProxy {
  static GetAllOpen = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/open",
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetSingleOpen = (openId, callback) => {
    let params = {
      id: openId,
    };

    restAPICall(
      Constants.MANAGER_URL + "/open",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static CheckOpenAvailable = (open, callback) => {
    let params = {
      open: open,
    };

    restAPICall(
      Constants.MANAGER_URL + "/open/available",
      "get",
      Constants.userToken,
      params,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static AddOpen = (open, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/open",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(open),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static UpdateOpen = (open, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/open",
      "put",
      Constants.userToken,
      undefined,
      JSON.stringify(open),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static DeleteOpen = (open, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/open",
      "delete",
      Constants.userToken,
      undefined,
      JSON.stringify(open),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };
}
